




































































































































import { Component, Prop, Emit, Vue, Watch } from 'vue-property-decorator';
import DSelectbox from '@/components/DSelectbox/selectbox.vue';
import TreeDropDownBox from '@/components/TreeDropDownBox/tree-drop-down-box.vue';
import TreeDropDownBoxBalance from '@/components/TreeDropDownBox/tree-drop-down-box-balance.vue';
import TreeDropDownBoxSingleCheckCutsList from '@/components/TreeDropDownBox/tree-drop-down-box-single-check-cuts-list.vue';
import dicts_cache_service from '@/services/dicts_cache_service';
import BalanceService, { BalancePreset, groupingDataSource } from '@/services/balance-service';
import YearService from '@/services/years-service';
import {
  CutType,
  EcoFilialSelectionType,
  EcoObjectType,
  FilialNodeTree,
  Period,
  EcoNodeSelectionType,
  YearType, 
  SelectedGroupedObjects
} from '@/services/models-service';
import { DxCheckBox } from 'devextreme-vue/check-box';
import DxSelectBox from 'devextreme-vue/select-box';
import DxRadioGroup from 'devextreme-vue/radio-group';
import DxTagBox from 'devextreme-vue/tag-box';
import DButton from '@/components/DButton/button.vue';
import Nebalans from '@/components/HeaderSet/Nebalans.vue';
import _ from 'lodash';
import cutService from '@/services/cut-service';
import ShareService from '@/services/share-service';
import EcoObjectsService from "@/services/eco-objects-service";
import { convertPeriodsListToMonthArray } from '@/utils/periods';
import UserAccessService from '@/services/user_access_service';
import UserPresetService from '@/services/user_preset_service';
import AuthService from '@/services/auth_service';
import PeriodTreeSelect from '@/components/PeriodTreeSelect/period-tree-select.vue';
import PeriodTreeSelectNew from '@/components/PeriodTreeSelect/PeriodTreeSelectNew.vue';
import {DxButton} from "devextreme-vue/ui/button";
import DPeriodTreeSelect from "@/components/PeriodTreeSelect/DPeriodTreeSelect.vue";
import GroupedObjectService from "@/services/grouped-object_service";
import ImbalanceService from '@/services/imbalance_service';


interface CutsList {
  year_id: string;
  year_name: number;
  nodes: { 
    name: string; 
    id: string;
    strong_tariff_calc: boolean;
    check: boolean;
    disabled: boolean;
  }[];
}


@Component({
  name: 'BalanceHeaderSetIntegrated',
  components: {
    TreeDropDownBoxSingleCheckCutsList,
    DPeriodTreeSelect,
    DSelectbox,
    DxSelectBox,
    DxCheckBox,
    TreeDropDownBoxBalance,
    DxRadioGroup,
    DxTagBox,
    DButton,
    Nebalans,
    PeriodTreeSelect,
    PeriodTreeSelectNew,
  }
})
export default class extends Vue {
  @Prop({default: false}) public disableSaveButton!: boolean;
  @Prop({default: false}) public showCorrelation!: boolean

  public service = BalanceService;
  public shareService = ShareService;
  public ecoService = EcoObjectsService;

  public fetchPreset = true;

  public preset = new BalancePreset();
  private currentCut: CutType | null = null;
  
  public year_ds = YearService.YearList;
  public period_ds = dicts_cache_service.periods_simple;
  public cut_ds: CutType[] = [];
  
  public cutsList: CutsList[] = [];
  public secondaryCutsList: CutsList[] = [];

  public availableLoad: boolean = true;
  public allowLoad: boolean = false;
  public periods: string[] = [];

  private groupingDS = groupingDataSource;

  public permission_nodes: any[] = [];
  public disableSelector: boolean = false;

  private selectionData: EcoFilialSelectionType[] = [];
  public display_internal_revolutions: boolean = false;
  public groupedObjects: SelectedGroupedObjects[] = [];
  public objectService = GroupedObjectService;
  public selectedGroupedObjects: string[] = [];
  public isGroupedSelected: boolean = false;
  // Блокирует кнопку загрузки после нажатия до следующего изменения фильтров
  private loadLocked: boolean = false;

  // Реальные выборы (только элементы с check === true)
  private realSelectedFilials: number[] = [];
  private realSelectedNodes: number[] = [];
  private realSelectedFacilities: number[] = [];
  
  private savedSelectionBeforeCutClear: {
    nodes: number[];
    filials: number[];
    facilities: number[];
    show_pao_tplus: boolean;
  } | null = null;


  private async createGroupedObjectStructure() {
    if (this.preset.id_cut) {
      let groupedObjects = await this.objectService.getObjectsByCut(this.preset.id_cut ?? '');
      this.groupedObjects = groupedObjects.map(el => ({
        id: el.id,
        title: el.title,
        check: this.groupedObjects.find(existing => existing.id === el.id)?.check || false,
      }));
    } else {
      this.groupedObjects = [];
    }
  }
  onSelectionRealChanged(selection: {
    filials: number[];
    nodes: number[];
    facilities: number[];
    t_plus?: boolean;
  }) {
    // Сохраняем реальные выборы (только элементы с check === true)
    this.realSelectedFilials = selection.filials || [];
    this.realSelectedNodes = selection.nodes || [];
    this.realSelectedFacilities = selection.facilities || [];
    if (selection.t_plus !== undefined) {
      this.preset.show_pao_tplus = selection.t_plus;
    }
    this.$emit('selectionRealChanged', selection);
    this.unlockLoadButton();
  }

  onDisplayChange(e: any) {
    const newValue = e.value;
    this.display_internal_revolutions = newValue;
    this.isLoadButtonDisabled = false
    this.$emit('displayInternalRevolutions', newValue);
    this.unlockLoadButton();
  }

  get relative_cut(): CutType[] {
    return this.cut_ds.filter((c) => 
      (c.visible_for === 'Видимый для администратора' || c.visible_for === 'Видимый для всех')
    );
  }

  get relative_compare_cut(): CutType[] {
    if (this.preset.id_cut && this.currentCut) {
      return this.relative_cut.filter((c: CutType) => {
        return (c.id !== this.preset.id_cut) && (this.currentCut?.id_eco_version === c.id_eco_version);
      });
    }
    return [];
  }

  get compareCutWithNone() {
    return this.relative_compare_cut;
  }

  get availableNodes() {
    return this.selectionData.length > 0;
  }

  public isLoadButtonDisabled: boolean = true;

  @Watch('service.current.show_correlation')
  @Watch('service.current.show_deviation')
  onDisplayOptionsChanged() {
    this.unlockLoadButton();
  }

  @Watch('loadButtonDisables')
  onLoadButtonDisablesChanged(newVal: boolean) {
    this.isLoadButtonDisabled = newVal;
  }

  get loadButtonDisables(): boolean {
    return this.loadLocked || !this.allowLoad || !this.availableNodes || this.service.isBalanceLoading
  }

  private lockLoadButton() {
    this.loadLocked = true;
    this.isLoadButtonDisabled = true;
  }

  private unlockLoadButton() {
    this.loadLocked = false;
    this.isLoadButtonDisabled = false;
  }

  async mounted() {
    this.fetchPreset = true;
    const today = new Date();
    this.service.loadFromCache();
    this.preset = _.cloneDeep(this.service.current);
    this.disableSelector = AuthService.isHeatNodeOperator();

    this.cut_ds = dicts_cache_service.cuts || [];
    
    this.getCutsList();

    if (this.preset.id_cut) {
      this.currentCut = this.cut_ds.find((c: CutType) => c.id === this.preset.id_cut) || null;
      if (this.currentCut) {
        this.preset.id_year = this.findYearIdByCutId(this.cutsList, this.preset.id_cut);
      }
    } else {
      this.currentCut = null;
      if (!this.preset.id_year) {
        const current_year = Number(today.getFullYear());
        const default_year = this.year_ds.find(y => y.name === current_year);
        if (default_year) {
          this.preset.id_year = default_year.id;
        } else if (this.year_ds.length) {
          this.preset.id_year = this.year_ds[this.year_ds.length - 1].id;
        }
      }
    }

    if (!this.preset.period || this.preset.period.length < 1) {
      const current_month = today.toLocaleString("en-US", {month: 'long'}).toLowerCase();
      const default_period: Period = dicts_cache_service.periods.find((p: Period) => p.name === current_month);
      this.periods = [default_period.name || 'may'];
      this.preset.period = this.periods;
    } else {
      this.periods = this.preset.period;
    }

    await this.updateFilialNodesTree();

    if (this.disableSelector) {
      let user_nodes = AuthService.getHeatNodeId();
      this.preset.show_pao_tplus = false;
      this.preset.id_eco_heat_nodes = user_nodes;
      
      let filials_set = new Set<number>();
      for (const filial_uid in this.ecoService.filialNodesTree) {
        const filial_nodes = this.ecoService.filialNodesTree[filial_uid];
        for (const node_uid in filial_nodes) {
          const node = filial_nodes[node_uid];
          if (user_nodes.indexOf(node.id) !== -1) {
            filials_set.add(node.filial_id);
          }
        }
      }
      this.preset.id_eco_filials = Array.from(filials_set);
    }

    let route = this.$route.name;
    if (route) {
      this.permission_nodes = UserAccessService.checkReading(route);
    }

    if (this.realSelectedFilials.length === 0 && this.realSelectedNodes.length === 0 && this.realSelectedFacilities.length === 0) {
      this.realSelectedFilials = this.preset.id_eco_filials ? this.preset.id_eco_filials.slice() : [];
      this.realSelectedNodes = this.preset.id_eco_heat_nodes ? this.preset.id_eco_heat_nodes.slice() : [];
      this.realSelectedFacilities = this.preset.id_eco_facilities ? this.preset.id_eco_facilities.slice() : [];
    }

    this.createSelectionTreeStructure();
    await this.createGroupedObjectStructure();

    Vue.nextTick(() => {
      this.fetchPreset = false;
      this.seekPreset();
    });
  }

  async updateFilialNodesTree() {
    const year = this.getYear(this.year_ds) || null;
    const months = this.getMonthList();
    if (this.currentCut && year && months.length > 0) {
      await this.ecoService.update_filial_nodes_tree(this.currentCut.id_eco_version, year.name, months);
      await this.ecoService.update_filial_facilities_tree(this.currentCut.id_eco_version, year.name, months);
    }
  }

  getYear(year_ds: any[]) {
    return year_ds.find((y: YearType) => y.id === this.preset.id_year);
  }

  getCut(cut_ds: any[]) {
    return cut_ds.find((c: CutType) => c.id === this.preset.id_cut);
  }

  getMonthList() {
    let month_set: any[] = [];

    this.periods.forEach((period_name: string) => {
      const prd = this.period_ds.find((period: any) => {
        return period.name === period_name;
      });

      if (prd) {
        month_set = prd.months.slice();
      }
    });

    return Array.from(new Set(month_set));
  }

  checkNodeAccess(nodeId: any) {
    return this.permission_nodes.includes(parseInt(nodeId));
  }

  private createSelectionTreeStructure() {
    let selectionData: EcoFilialSelectionType[] = [];
    let data = _.cloneDeep(this.ecoService.filialNodesFacilitiesTree)
    if (!data) return

    const savedRealFilials = this.realSelectedFilials.slice();
    const savedRealNodes = this.realSelectedNodes.slice();
    const savedRealFacilities = this.realSelectedFacilities.slice();

    let result: EcoFilialSelectionType[] = []
    
    // Определяем какие элементы реально выбраны (только те, что были явно выбраны)
    const realSelectedFilialsSet = new Set(savedRealFilials);
    const realSelectedNodesSet = new Set(savedRealNodes);
    const realSelectedFacilitiesSet = new Set(savedRealFacilities);

    // Объект ЕСО может в переходный период попасть сразу в два тепловых узла
    // (например, при смене ТУ - см. п. 231/222 реестра замечаний). Не даём ему
    // задвоиться в списке выбора - добавляем только при первой встрече за месяц.
    const seenFacilityIds = new Set<number>();

    for(let fillial in data){
      const fillialId = Number(fillial);
      // Филиал выбран ТОЛЬКО если он явно в сохраненных реальных выборах
      const isFilialSelected = realSelectedFilialsSet.has(fillialId);
      
      result.push({
        check: isFilialSelected,
        name: data[fillial].name,
        id: fillialId,
        nodes: []
      })

      const fillialIndex = result.findIndex((i: any) => i.id === fillialId);
      
      for(let node in data[fillial].nodes){
        const nodeId = Number(node);
        // Узел выбран если он в сохраненных реальных узлах (независимо от состояния филиала)
        const isNodeSelected = realSelectedNodesSet.has(nodeId);
        
        if(data[fillial].nodes){
          result[fillialIndex].nodes.push({
            check: isNodeSelected,
            name: data[fillial].nodes[node].name,
            id: nodeId,
            facilities: []
          })
          
          const nodeIndex = result[fillialIndex].nodes.findIndex((n: any) => n.id === nodeId);
          
          if (data[fillial].nodes[node].objects && data[fillial].nodes[node].objects.objects){
            const length = data[fillial].nodes[node].objects?.objects?.length ?? 0;
            for (let i = 0; i < length; i++) {
              const objs = data[fillial].nodes[node].objects.objects!;

              if (objs[i]) {
                const facilityId = objs[i].id!;

                // Пропускаем, если этот объект уже добавлен под другим узлом
                if (seenFacilityIds.has(facilityId)) {
                  continue;
                }
                seenFacilityIds.add(facilityId);

                // Объект выбран если он в сохраненных реальных объектах (независимо от состояния узла и филиала)
                const isFacilitySelected = realSelectedFacilitiesSet.has(facilityId);

                result[fillialIndex].nodes[nodeIndex].facilities!.push({
                  check: isFacilitySelected,
                  id: facilityId,
                  name: objs[i].name!
                });
              }
            }
          }
        }
      }
    }

    this.selectionData = result;
    
    // Обновляем локальные переменные с реальными выборами для синхронизации
    this.realSelectedFilials = savedRealFilials;
    this.realSelectedNodes = savedRealNodes;
    this.realSelectedFacilities = savedRealFacilities;
    
    const preservedRealFilials = savedRealFilials.slice();
    const preservedRealNodes = savedRealNodes.slice();
    const preservedRealFacilities = savedRealFacilities.slice();
    
    // Обновляем поля пресета для загрузки данных на основе текущего состояния дерева
    // (нужны иерархические данные для API, даже если мы сохраняем только реальные выборы)
    this.updatePresetForDataLoading();
    
    this.preset.id_eco_filials = preservedRealFilials;
    this.preset.id_eco_heat_nodes = preservedRealNodes;
    this.preset.id_eco_facilities = preservedRealFacilities;
    
    // emitChanges будет вызван автоматически через watch('selectionBlock') в tree-drop-down-box.vue
    // после того как this.selectionData обновится и синхронизируется с selectionBlock
    
    this.checkAvailable();
  }

  // Объект ЕСО может числиться сразу в нескольких тепловых узлах (см. п. 231
  // реестра замечаний). Список выбора (selectionData) показывает такой объект
  // только один раз, поэтому для построения запроса к бэкенду узлы нужно искать
  // не по selectionData, а по исходному дереву ЕСО - иначе данные по второму узлу
  // не попадут в фильтр heat_node_id и пропадут из Сводных данных.
  private getNodesForFacility(facilityId: number): number[] {
    const data = this.ecoService.filialNodesFacilitiesTree;
    if (!data) return [];
    const nodeIds: number[] = [];
    for (const filialKey in data) {
      const nodes = data[filialKey].nodes || {};
      for (const nodeKey in nodes) {
        const objects = nodes[nodeKey].objects?.objects || [];
        if (objects.some((obj: any) => obj && obj.id === facilityId)) {
          nodeIds.push(Number(nodeKey));
        }
      }
    }
    return nodeIds;
  }

  // Обновляет поля пресета для загрузки данных на основе текущего состояния дерева
  // Эта логика должна соответствовать onHierarchyChanged() - вычислять иерархические данные для API
  private updatePresetForDataLoading() {
    const nodesForLoading = new Set<number>();
    const filialsForLoading = new Set<number>();
    const facilitiesForLoading: number[] = [];
    
    // Логика аналогична onHierarchyChanged():
    // 1. Если филиал выбран - все его узлы добавляются
    // 2. Если узел выбран (филиал не выбран) - только этот узел
    // 3. Если объект выбран (узел и филиал не выбраны) - добавляется родительский узел и объект
    
    for (const filial of this.selectionData) {
      if (filial.check === true) {
        // Филиал выбран - добавляем филиал и все его узлы
        filialsForLoading.add(filial.id);
        filial.nodes.forEach(node => {
          nodesForLoading.add(node.id);
        });
      } else {
        // Филиал не выбран - проверяем узлы и объекты
        for (const node of filial.nodes || []) {
          if (node.check === true) {
            // Узел выбран - добавляем только этот узел
            nodesForLoading.add(node.id);
          } else {
            // Проверяем объекты узла
            if (node.facilities) {
              for (const facility of node.facilities) {
                if (facility.check === true) {
                  // Объект выбран - добавляем ВСЕ узлы, где он числится в ЕСО,
                  // а не только тот, под которым он показан в (дедуплицированном) списке
                  facilitiesForLoading.push(facility.id);
                  const facilityNodes = this.getNodesForFacility(facility.id);
                  if (facilityNodes.length > 0) {
                    facilityNodes.forEach(nid => nodesForLoading.add(nid));
                  } else {
                    nodesForLoading.add(node.id);
                  }
                }
              }
            }
          }
        }
      }
    }
    
    // Обновляем поля пресета для загрузки данных
    this.preset.id_eco_heat_nodes = Array.from(nodesForLoading);
    this.preset.id_eco_facilities = facilitiesForLoading;
    
    // Добавляем филиалы, у которых есть выбранные узлы
    nodesForLoading.forEach(nodeId => {
      for (const filial of this.selectionData) {
        const hasNode = filial.nodes && filial.nodes.some(n => n.id === nodeId);
        if (hasNode) {
          filialsForLoading.add(filial.id);
        }
      }
    });
    this.preset.id_eco_filials = Array.from(filialsForLoading);
  }

  confirmSave() {
    // Сохраняем только реально выбранные элементы (без автоматического включения дочерних)
    this.preset.id_eco_filials = this.realSelectedFilials.slice();
    this.preset.id_eco_heat_nodes = this.realSelectedNodes.slice();
    this.preset.id_eco_facilities = this.realSelectedFacilities.slice();
    this.preset.show_deviation = this.service.current.show_deviation;
    this.preset.show_correlation = this.service.current.show_correlation;
    this.service.selectedGroupedObject = this.selectedGroupedObjects.slice();
    this.service.setCurrent({ ...this.preset });
  }

  onGroupedObjectChanged(items: string[]) {
    this.selectedGroupedObjects = items;
    if (items.length){
      this.preset.show_selected_nodes_facility = true
      this.isGroupedSelected = true
    } else {
       this.isGroupedSelected = false
    }
    this.seekPreset();
    this.$emit('selectedGroupedObjectChanged', items);
    this.unlockLoadButton();
  }

  onHierarchyChanged({ filials, nodes, facilities }: {
    filials: number[];
    nodes: number[];
    facilities: number[];
  }) {
    if (this.fetchPreset) {
      return;
    }
    
    if (this.preset.show_pao_tplus) {
      this.preset.id_eco_heat_nodes = nodes;
      this.preset.id_eco_facilities = facilities;
      this.preset.id_eco_filials = filials;
    } else {
      // Обычная логика обработки индивидуальных выборов
      const nodesSelected = new Set<number>();

      // Добавляем явно выбранные узлы
      nodes.forEach(nodeId => nodesSelected.add(nodeId));

      // Добавляем узлы, к которым относятся выбранные объекты (по исходному дереву
      // ЕСО, а не по дедуплицированному selectionData - см. getNodesForFacility)
      for (const facilityId of facilities) {
        const facilityNodes = this.getNodesForFacility(facilityId);
        facilityNodes.forEach(nid => nodesSelected.add(nid));
      }

      this.preset.id_eco_heat_nodes = Array.from(nodesSelected);
      this.preset.id_eco_facilities = facilities;
      
      const selectedFilials = new Set<number>();
      
      // Добавляем явно выбранные филиалы
      filials.forEach(filialId => selectedFilials.add(filialId));
      
      // Добавляем филиалы, у которых есть выбранные узлы
      for (const filial of this.selectionData) {
        const hasSelectedNodes = filial.nodes.some(node => nodes.includes(node.id));
        if (hasSelectedNodes) {
          selectedFilials.add(filial.id);
        }
      }
      this.preset.id_eco_filials = Array.from(selectedFilials);
    }

    const selectedNames: string[] = [];
    for (const filial of this.selectionData) {
      for (const node of filial.nodes) {
        if (nodes.includes(node.id)) {
          selectedNames.push(node.name);
        }
      }
    }
    this.$emit('selectedObjectsChanged', selectedNames);
    this.unlockLoadButton();
  }

  @Emit('onLoad')
  onLoad() {
    ImbalanceService.getImbalanceColors()
    this.allowLoad = false;
    this.lockLoadButton();
    
    // Сохраняем реальные выборы в пресет (для сохранения в кеш)
    this.preset.id_eco_filials = this.realSelectedFilials.slice();
    this.preset.id_eco_heat_nodes = this.realSelectedNodes.slice();
    this.preset.id_eco_facilities = this.realSelectedFacilities.slice();
    this.preset.show_deviation = this.service.current.show_deviation;
    this.preset.show_correlation = this.service.current.show_correlation;
    // Сохраняем выбранные групповые объекты (аналогично confirmSave)
    this.service.selectedGroupedObject = this.selectedGroupedObjects.slice();
    
    // Сохраняем реальные выборы для последующего восстановления
    const savedRealFilials = this.realSelectedFilials.slice();
    const savedRealNodes = this.realSelectedNodes.slice();
    const savedRealFacilities = this.realSelectedFacilities.slice();
    
    this.service.setCurrent({ ...this.preset });
    
    // Обновляем поля пресета для загрузки данных на основе текущего состояния дерева
    this.updatePresetForDataLoading();
    
    Object.assign(this.service.current, _.cloneDeep(this.preset));
    
    // Восстанавливаем реальные выборы в пресет (для следующего сохранения)
    this.preset.id_eco_filials = savedRealFilials;
    this.preset.id_eco_heat_nodes = savedRealNodes;
    this.preset.id_eco_facilities = savedRealFacilities;
    
    this.seekCutName();
    this.isLoadButtonDisabled = true;
  }

  @Emit('onSave')
  onSave() {}

  @Emit('onExport')
  onExport() {}

  @Emit('checkAvailable')
  checkAvailable() {
    return this.selectionData.length > 0;
  }

  @Emit('checkAllFilters')
  checkAllFilters() {
    return this.preset.id_year && this.preset.period?.length && this.preset.id_cut;
  }

  @Watch('preset.id_cut')
  async changeCutId(newCutId: string | null, oldCutId: string | null) {
    if (this.fetchPreset) {
      return;
    }

    if (!newCutId) {
      this.savedSelectionBeforeCutClear = {
        nodes: this.realSelectedNodes.slice(),
        filials: this.realSelectedFilials.slice(),
        facilities: this.realSelectedFacilities.slice(),
        show_pao_tplus: this.preset.show_pao_tplus
      };
      
      this.currentCut = null;
      this.preset.id_eco_heat_nodes = [];
      this.preset.id_eco_filials = [];
      this.preset.id_eco_facilities = [];
      this.preset.show_pao_tplus = false;
      this.selectionData = [];
      this.realSelectedFilials = [];
      this.realSelectedNodes = [];
      this.realSelectedFacilities = [];
    } else {
      this.currentCut = this.cut_ds.find(cut => newCutId === cut.id) || null;
      
      this.preset.id_year = this.findYearIdByCutId(this.cutsList, newCutId);
      
      await this.updateFilialNodesTree();
      
      const previousSelection = this.savedSelectionBeforeCutClear || {
        nodes: this.realSelectedNodes.slice(),
        filials: this.realSelectedFilials.slice(),
        facilities: this.realSelectedFacilities.slice(),
        show_pao_tplus: this.preset.show_pao_tplus
      };
      
      await this.restoreSelection(previousSelection);
      
      this.savedSelectionBeforeCutClear = null;
    }
    
    await this.createGroupedObjectStructure();
    this.unlockLoadButton();
  }

  private async restoreSelection(previousSelection: {
    nodes: number[];
    filials: number[];
    facilities?: number[];
    show_pao_tplus: boolean;
  }) {
    const availableNodes: number[] = [];
    const availableFilials: Set<number> = new Set();
    const nodeToFilialMap = new Map<number, number>();
    
    for (const filial_uid in this.ecoService.filialNodesTree) {
      const filial_nodes = this.ecoService.filialNodesTree[filial_uid];
      
      for (const node_uid in filial_nodes) {
        const node = filial_nodes[node_uid];
        if (this.checkNodeAccess(node.id)) {
          availableNodes.push(node.id);
          availableFilials.add(node.filial_id);
          nodeToFilialMap.set(node.id, node.filial_id);
        }
      }
    }
    
    const restoredNodes = previousSelection.nodes.filter(nodeId => 
      availableNodes.includes(nodeId)
    );
    
    const availableFilialsArray = Array.from(availableFilials);
    const restoredFilials = previousSelection.filials.filter(filialId => 
      availableFilialsArray.includes(filialId)
    );
    
    const availableFacilities: number[] = [];
    if (this.ecoService.filialNodesFacilitiesTree) {
      for (const filialUid in this.ecoService.filialNodesFacilitiesTree) {
        const filialData = this.ecoService.filialNodesFacilitiesTree[filialUid];
        if (filialData.nodes) {
          for (const nodeUid in filialData.nodes) {
            const nodeData = filialData.nodes[nodeUid];
            if (nodeData.objects && nodeData.objects.objects) {
              nodeData.objects.objects.forEach((obj: any) => {
                if (obj.id) {
                  availableFacilities.push(obj.id);
                }
              });
            }
          }
        }
      }
    }
    
    const restoredFacilities = previousSelection.facilities 
      ? previousSelection.facilities.filter(facilityId => availableFacilities.includes(facilityId))
      : [];
    
    this.preset.id_eco_heat_nodes = restoredNodes;
    this.preset.id_eco_filials = restoredFilials;
    this.preset.id_eco_facilities = restoredFacilities;
    this.preset.show_pao_tplus = previousSelection.show_pao_tplus && (restoredNodes.length > 0 || restoredFacilities.length > 0);
    
    this.realSelectedFilials = restoredFilials;
    this.realSelectedNodes = restoredNodes;
    this.realSelectedFacilities = restoredFacilities;
    
    this.createSelectionTreeStructure();
  }

  @Watch('preset.id_compare_cut')
  changeCompareCut() {
    this.preset.show_compare_cut = true;
    this.unlockLoadButton();
  }

  @Watch('preset.show_cut')
  resetCut() {
    if (this.fetchPreset) {
      return;
    }
    this.preset.id_cut = null;
    this.unlockLoadButton();
  }

  @Watch('preset.show_compare_cut')
  resetSecondaryCut() {
    if (this.fetchPreset) {
      return;
    }
    this.preset.id_compare_cut = null;
    this.unlockLoadButton();
  }

  @Emit('cutName')
  seekCutName() {
    const result = {name: '', secondary: ''};
    result.name = this.currentCut?.name || "";
    if (this.preset.show_compare_cut && this.preset.id_compare_cut) {
      const compare_cut = this.relative_cut.find(c => c.id === this.preset.id_compare_cut);
      result.secondary = compare_cut ? compare_cut.name : "";
    }
    return result;
  }

  @Watch('preset', { deep: true })
  seekPreset() {
    if (this.fetchPreset) {
      return;
    }

    this.availableLoad = true;
    if (
      this.preset.id_cut &&
      this.preset.period?.length > 0 &&
      (this.preset.show_pao_tplus || (this.preset.id_eco_heat_nodes.length) || (this.selectedGroupedObjects.length))
    ) {
      this.allowLoad = true;
    } else {
      this.allowLoad = false;
    }
    this.service.allowExcelExport = false;

    this.shareService.share_year_id = this.preset.id_year;
    this.shareService.share_cut_id = this.preset.id_cut;
  }

  @Watch('preset.grouping')
  onGroupingChanged() {
    this.unlockLoadButton();
  }

  @Watch('periods')
  async changePeriods(newValue: any, oldValue: any) {
    if (this.fetchPreset) {
      return;
    }

    this.preset.period = this.periods;
    
    // Сохраняем реальные выборы перед обновлением дерева
    const savedRealFilials = this.realSelectedFilials.slice();
    const savedRealNodes = this.realSelectedNodes.slice();
    const savedRealFacilities = this.realSelectedFacilities.slice();

    // Обновляем дерево для нового периода
    await this.updateFilialNodesTree();
    
    // Восстанавливаем реальные выборы в пресет перед вызовом createSelectionTreeStructure
    // (та же логика, что и при восстановлении из пресета)
    this.preset.id_eco_filials = savedRealFilials;
    this.preset.id_eco_heat_nodes = savedRealNodes;
    this.preset.id_eco_facilities = savedRealFacilities;
    
    // Используем createSelectionTreeStructure для правильного восстановления
    this.createSelectionTreeStructure();
    await this.createGroupedObjectStructure();
    this.unlockLoadButton();
  }

  getCutsList() {
    for (let year of this.year_ds) {
      let nodes = dicts_cache_service.cuts
        .filter((c: any) => 
          c.id_year === year.id &&
          (c.visible_for === 'Видимый для администратора' || c.visible_for === 'Видимый для всех')
        )
        .map((c: any) => ({
          id: c.id,
          name: c.name,
          strong_tariff_calc: c.strong_tariff_calc,
          disabled: c.disabled
        }));

      if (nodes.length > 0) {
        nodes = _.sortBy(nodes, (o) => o.number);
        this.cutsList.push({
          year_id: year.id,
          year_name: year.name,
          nodes
        });
      }
    }
    this.secondaryCutsList = _.cloneDeep(this.cutsList);
  }

  private findYearIdByCutId(cuts: CutsList[], cutId: string | null): string | null {
    for (const cut of cuts) {
      if (cut.nodes.some(node => node.id === cutId)) {
        return cut.year_id;
      }
    }
    return this.preset.id_year || null;
  }

  private onCutRestored(cutId: string) {
    this.$nextTick(async () => {
      await this.updateFilialNodesTree();
      this.createSelectionTreeStructure();
    });
  }
}
